import { type FC, type ReactNode, useCallback, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { TourContext } from '@/contexts/Tour/Context';

export const TourProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [activeTour, setActiveTour] = useState<string | null>(null);
  const location = useLocation();
  const prevPathname = useRef(location.pathname);

  const startTour = (tourId: string) => {
    setActiveTour(tourId);
  };

  const endTour = useCallback(() => {
    setActiveTour(null);
  }, []);

  const isTourActive = (tourId: string) => {
    return activeTour === tourId;
  };

  // End tour when route changes
  useEffect(() => {
    if (prevPathname.current !== location.pathname && activeTour !== null) {
      endTour();
    }
    prevPathname.current = location.pathname;
  }, [location.pathname, activeTour, endTour]);

  return <TourContext.Provider value={{ activeTour, startTour, endTour, isTourActive }}>{children}</TourContext.Provider>;
};
